import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import {
  IAPIActivityGraphDataModel,
  IAPIActivityGraphModel,
} from "../interfaces/IAPIDashboardModels";

export class ActivityGraphWidgetDataModel {
  currentPeriodValue: number;
  previousPeriodValue: number;
  projectedValue: number;
  previousProjectedValue: number;
  type: string;
  filter: string;
  graphData: ActivityGraphDataModel[];
  currentPeriodStart: Date;
  currentPeriodEnd: Date;
  previousPeriodStart: Date;
  previousPeriodEnd: Date;
  projectedPeriodStart: Date;
  projectedPeriodEnd: Date;
  priorActualPeriodStart: Date;
  priorActualPeriodEnd: Date;

  priorDay: Date;
  priorMonthStart: Date;
  priorMonthEnd: Date;
  priorYearStart: Date;
  priorYearEnd: Date;
  constructor(data?: Partial<ActivityGraphWidgetDataModel>) {
    this.currentPeriodValue = data?.currentPeriodValue || 0;
    this.previousPeriodValue = data?.previousPeriodValue || 0;
    this.projectedValue = data?.projectedValue || 0;
    this.previousProjectedValue = data?.previousProjectedValue || 0;
    this.type = data?.type || "";
    this.filter = data?.filter || "";
    this.graphData =
      data?.graphData?.map((s) => new ActivityGraphDataModel(s)) || [];
    this.currentPeriodStart = data?.currentPeriodStart || new Date();
    this.currentPeriodEnd = data?.currentPeriodEnd || new Date();
    this.previousPeriodStart = data?.previousPeriodStart || new Date();
    this.previousPeriodEnd = data?.previousPeriodEnd || new Date();
    this.projectedPeriodStart = data?.projectedPeriodStart || new Date();
    this.projectedPeriodEnd = data?.projectedPeriodEnd || new Date();
    this.priorActualPeriodStart = data?.priorActualPeriodStart || new Date();
    this.priorActualPeriodEnd = data?.priorActualPeriodEnd || new Date();

    this.priorDay = data?.priorDay || new Date();
    this.priorMonthStart = data?.priorMonthStart || new Date();
    this.priorMonthEnd = data?.priorMonthEnd || new Date();
    this.priorYearStart = data?.priorYearStart || new Date();
    this.priorYearEnd = data?.priorYearEnd || new Date();
  }

  static deserializeAPIModel(
    data: IAPIActivityGraphModel
  ): ActivityGraphWidgetDataModel {
    const isToday = data.filter?.toUpperCase() === "TODAY";

    const mappedData: Partial<ActivityGraphWidgetDataModel> = {
      currentPeriodValue: data.currentPeriodValue,
      previousPeriodValue: data.previousPeriodValue,
      projectedValue: data.projectedValue,
      previousProjectedValue: data.previousProjectedValue,
      type: data.type,
      filter: data.filter,
      graphData: data.graphData?.map((s) =>
        ActivityGraphDataModel.deserializeAPIModel(s, isToday)
      ),
      currentPeriodStart: UtilityMethods.removeZFromDateString(
        data.currentPeriodStart
      ),
      currentPeriodEnd: UtilityMethods.removeZFromDateString(
        data.currentPeriodEnd
      ),
      previousPeriodStart: UtilityMethods.removeZFromDateString(
        data.previousPeriodStart
      ),
      previousPeriodEnd: UtilityMethods.removeZFromDateString(
        data.previousPeriodEnd
      ),
      projectedPeriodStart: UtilityMethods.removeZFromDateString(
        data.projectedPeriodStart
      ),
      projectedPeriodEnd: UtilityMethods.removeZFromDateString(
        data.projectedPeriodEnd
      ),
      priorActualPeriodStart: UtilityMethods.removeZFromDateString(
        data.priorActualPeriodStart
      ),
      priorActualPeriodEnd: UtilityMethods.removeZFromDateString(
        data.priorActualPeriodEnd
      ),
      priorDay: UtilityMethods.removeZFromDateString(data.priorDay),
      priorMonthStart: UtilityMethods.removeZFromDateString(
        data.priorMonthStart
      ),
      priorMonthEnd: UtilityMethods.removeZFromDateString(data.priorMonthEnd),
      priorYearStart: UtilityMethods.removeZFromDateString(data.priorYearStart),
      priorYearEnd: UtilityMethods.removeZFromDateString(data.priortYearEnd),
    };

    //mappedData.graphData = (mappedData.graphData || []).sort((a, b) => a.date.getTime() - b.date.getTime());
    return new ActivityGraphWidgetDataModel(mappedData);
  }
}

export class ActivityGraphDataModel {
  date: Date;
  currentPeriodValue: number;
  priorPeriodValue: number;
  projectedValue: number;
  value: number;
  dateLabel: string;
  isCurrentPeriod: boolean;
  isPriorPeriod: boolean;
  isProjected: boolean;
  isPriorActual: boolean;
  filter: string;
  priorActualValue: number;
  toolTipLabel: string;
  priorToolTipLabel: string;
  label: string;
  priorLabel: string;
  priorDate: Date;
  constructor(data?: Partial<ActivityGraphDataModel>) {
    this.date = new Date(data?.date || "");
    this.currentPeriodValue = data?.currentPeriodValue || 0;
    this.priorPeriodValue = data?.priorPeriodValue || 0;
    this.projectedValue = data?.projectedValue || 0;
    this.isCurrentPeriod = data?.isCurrentPeriod || false;
    this.isPriorPeriod = data?.isPriorPeriod || false;
    this.isProjected = data?.isProjected || false;
    this.isPriorActual = data?.isPriorActual || false;
    this.value = data?.value || 0;
    this.filter = data?.filter || "";
    this.dateLabel = UtilityMethods.formatDateInMonthAndDay(this.date);
    this.priorActualValue = data?.priorActualValue || 0;
    this.toolTipLabel = data?.toolTipLabel || "";
    this.label = data?.label || "";
    this.priorLabel = data?.priorLabel || "";
    this.priorDate = new Date(data?.priorDate || "");
    this.priorToolTipLabel = data?.priorToolTipLabel || "";
  }

  static deserializeAPIModel(
    data: IAPIActivityGraphDataModel,
    isTodayFilter: boolean
  ): ActivityGraphDataModel {
    const date = UtilityMethods.removeZFromDateString(data.date);
    const mappedData: Partial<ActivityGraphDataModel> = {
      value: data.value,
      date: date,
      currentPeriodValue: data.currentPeriodValue,
      priorPeriodValue: data.priorPeriodValue,
      projectedValue: data.projectedValue,
      isCurrentPeriod: data.isCurrentPeriod,
      isPriorPeriod: data.isPriorPeriod,
      isProjected: data.isProjected,
      isPriorActual: data.isPriorActual,
      priorActualValue: data.priorActualValue,
      toolTipLabel: UtilityMethods.getDayCommaMonthDate(date),
      priorToolTipLabel: UtilityMethods.getDayCommaMonthDate(
        UtilityMethods.removeZFromDateString(data.priorDate)
      ),
      label: data.label, //isTodayFilter ? UtilityMethods.formatHourAMPM(date) : data.label,
      priorDate: UtilityMethods.removeZFromDateString(data.priorDate),
    };
    return new ActivityGraphDataModel(mappedData);
  }
}
